import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { cn } from '@/lib/utils';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Explorar',
      links: [
        { label: 'Inicio', href: '/' },
        { label: 'Películas', href: '/movies' },
        { label: 'Mi Lista', href: '/favorites' },
        { label: 'Tendencias', href: '/movies' },
      ],
    },
    {
      title: 'Géneros',
      links: [
        { label: 'Acción', href: '/movies' },
        { label: 'Drama', href: '/movies' },
        { label: 'Ciencia Ficción', href: '/movies' },
        { label: 'Thriller', href: '/movies' },
      ],
    },
    {
      title: 'Información',
      links: [
        { label: 'Sobre Nosotros', href: '#' },
        { label: 'Contacto', href: '#' },
        { label: 'Preguntas Frecuentes', href: '#' },
        { label: 'Centro de Ayuda', href: '#' },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Términos de Uso', href: '#' },
        { label: 'Política de Privacidad', href: '#' },
        { label: 'Preferencias de Cookies', href: '#' },
        { label: 'Avisos Legales', href: '#' },
      ],
    },
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Youtube, href: '#', label: 'Youtube' },
  ];

  return (
    <footer className="bg-background border-t border-border/50 mt-auto">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-12 py-12 md:py-16">
        {/* Social Links */}
        <div className="flex items-center gap-4 mb-8 md:mb-12">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              aria-label={social.label}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary/50 text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors duration-300"
            >
              <social.icon className="w-5 h-5" />
            </a>
          ))}
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8 md:mb-12">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="text-foreground font-semibold text-sm mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-muted-foreground text-sm hover:text-foreground transition-colors duration-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/logo.png"
                alt="Cinemax"
                className="h-12 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </Link>

            {/* Copyright */}
            <p className="text-muted-foreground text-sm text-center">
              © {currentYear} CINEMAX. Todos los derechos reservados.
            </p>

            {/* Language Selector */}
            <button className="text-muted-foreground text-sm hover:text-foreground transition-colors border border-border/50 rounded-md px-4 py-2">
              🌐 Español
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
